// Giờ tích luỹ của TỪNG lượt làm quiz — cùng công thức cộng vào "Tổng thời
// gian đã tích luỹ" của môn: số câu đã trả lời × phút/câu (cấu hình môn,
// mặc định 0,5'). Lượt bị huỷ không tính; lượt đang làm chưa tính.
//
// Số câu đã trả lời lấy từ GET /quiz/attempts/batch (backend đếm từ Moodle),
// vì danh sách lượt làm của Moodle không có số này.

// { [attemptId]: { questionsAnswered, abandoned } } cho một quiz.
export function buildAttemptDataMap(batchData, quizId) {
  const list = batchData?.[quizId]?.attempts || batchData?.[String(quizId)]?.attempts || [];
  const map = {};
  list.forEach((a) => {
    if (a?.attemptId == null) return;
    map[a.attemptId] = {
      questionsAnswered: a.questionsAnswered,
      abandoned: !!a.abandoned || a.state === 'abandoned',
    };
  });
  return map;
}

// attempt: một phần tử của mod_quiz_get_user_attempts ({ id, state }).
// Trả { status: 'counted', answered, seconds, timePerQuestion } |
//     { status: 'abandoned', seconds: 0 } | null (chưa tính / chưa có dữ liệu).
export function attemptAccumulatedTime(attempt, attemptDataMap, timePerQuestion = 0.5) {
  const data = attemptDataMap?.[attempt?.id];
  if (attempt?.state === 'abandoned' || data?.abandoned) return { status: 'abandoned', seconds: 0 };
  if (attempt?.state !== 'finished') return null;
  if (!data || !Number.isFinite(Number(data.questionsAnswered))) return null;
  const answered = Number(data.questionsAnswered);
  const tpq = Number.isFinite(Number(timePerQuestion)) ? Number(timePerQuestion) : 0.5;
  return { status: 'counted', answered, seconds: answered * tpq * 60, timePerQuestion: tpq };
}
